import { useState, useEffect, useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const useAccountConfig = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])

  const fetchData = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await RequestService.getAccountConfigurations()
      setData(data || [])
    } catch (e) {
      console.log('useAccountConfig', e)
    }

    setLoading(false)
  })

  useEffect(() => {
    fetchData()
  }, [])

  return {
    loading,
    data,
  }
}

export default useAccountConfig
